import React, { FC }                                                                                                                                 from 'react';
import { ENVIRONMENT_IS_DEVELOPMENT, ENVIRONMENT_IS_PRODUCTION, ENVIRONMENT_IS_STAGING, ENVIRONMENT_IS_TESTING, ENVIRONMENT_LABEL, PRODUCT_VERSION } from '@src/constants';
import { CorvalBranchName }                                                                                                                          from "@src/views/components/product/CorvalBranchName";

//@ts-ignore
let environment = __ENV__;

interface Props {
    longVersion?: boolean,
}

const defaultProps: Props = {
    longVersion: false
}

const CorvalVersionNumber: FC<Props> = ( props ) => {

    let isProduction = ENVIRONMENT_IS_PRODUCTION,
        changeLogUrl = environment.changeLogURL;

    let branchDelimiterString = '%BRANCH%',
        branchURLs            = {
            dev:   environment.changeLogMainBranch,
            test:  environment.changeLogMainBranch,
            stage: environment.changeLogMainBranch,
            prod:  environment.changeLogMainBranch,
        };

    if( ENVIRONMENT_IS_DEVELOPMENT ){

        changeLogUrl = changeLogUrl.replace( branchDelimiterString, branchURLs.dev );

    } else {

        if( ENVIRONMENT_IS_TESTING ){
            changeLogUrl = changeLogUrl.replace( branchDelimiterString, branchURLs.test );
        }
        if( ENVIRONMENT_IS_STAGING ){
            changeLogUrl = changeLogUrl.replace( branchDelimiterString, branchURLs.stage );
        }
        if( ENVIRONMENT_IS_PRODUCTION ){
            changeLogUrl = changeLogUrl.replace( branchDelimiterString, branchURLs.prod );
        }

        // add branch url
        changeLogUrl = changeLogUrl.replace( branchDelimiterString, branchURLs.dev );

        // add product version to the url
        changeLogUrl = `${ changeLogUrl }#${ PRODUCT_VERSION }`;
    }

    const handleOnClick = () => {

        window.open( changeLogUrl, '_blank' );
    }

    const containerProps = isProduction ? {} : {
        onClick:   handleOnClick,
        className: 'cursor--pointer opacity-hover--80'
    }

    return (
        <span { ...containerProps }>
            { props.longVersion ? 'Version ' : 'v' }
            { PRODUCT_VERSION }
            { !ENVIRONMENT_IS_PRODUCTION ? ` (${ ENVIRONMENT_LABEL })` : null }
       </span>
    );
};

CorvalVersionNumber.defaultProps = defaultProps;

export { CorvalVersionNumber }
